<div class="p-dialog-content__dynamic">

  <ng-container *ngIf="!isLoading; else loadingTpl">
    <!-- Bulk toggle -->
    <div class="bulk-actions">
      <button class="link-btn" (click)="toggleAll(true)" [disabled]="allSelected">Select All</button>
      <span class="separator">|</span>
      <button class="link-btn" (click)="toggleAll(false)" [disabled]="noneSelected">Deselect All</button>
      <span class="hint">(Deselecting all resets to default — the user will see every widget)</span>
    </div>

    <ng-container *ngFor="let pageGroup of pageGroups">
      <h4 class="page-group-title">{{ pageGroup.page | fromUnderscoreToText | capitalizeFirstLetter }}</h4>
      <ul class="widgets-list">
        <li class="widgets-list__item" *ngFor="let widget of pageGroup.widgets">
          <p-checkbox
            [binary]="true"
            [(ngModel)]="widget.selected"
            [inputId]="'widget-' + widget.id"
          ></p-checkbox>
          <label [for]="'widget-' + widget.id" class="widget-label">
            {{ widget.name }}
          </label>
        </li>
      </ul>
    </ng-container>

    <div *ngIf="pageGroups.length === 0" class="no-data">
      No widgets available for this user type.
    </div>
  </ng-container>

  <ng-template #loadingTpl>
    <app-ngx-loader [loading]="true"></app-ngx-loader>
  </ng-template>
</div>

<div class="p-dialog-footer p-dialog-footer__dynamic">
  <button class="cancel-btn medium" (click)="cancelClicked()">Cancel</button>
  <button class="regular-btn medium" (click)="saveClicked()" [disabled]="isSubmitLoading || isLoading">
    Save
    <i *ngIf="isSubmitLoading" class="fa-spin fas fa-spinner ms-2"></i>
  </button>
</div>
